import { cn } from "../../../../lib/cn";
import { paletteSurfaceClass } from "./palette";

interface StatusDotProps {
  /** Palette path (e.g. 'success.main') or any CSS colour. */
  color: string;
}

/** 8px status dot. Decorative — a status word must reach the user elsewhere. */
export const StatusDot = ({ color }: StatusDotProps) => (
  <span
    aria-hidden
    className={cn("inline-block size-2 shrink-0 rounded-full", paletteSurfaceClass[color])}
    style={paletteSurfaceClass[color] === undefined ? { backgroundColor: color } : undefined}
  />
);
